import {
  LINE_INFO,
  CUSTOMER_SELECTED,
  PHARMACY_SELECTED,
  SET_SYSTEM_CONSTANTS,
  EXCLUSION_ERROR_FLAG,
  FAMILIES_DATA,
  PRESCRIPTION_TYPE,
  PRESCRIPTION_DIRECTOR,
  PRESCRIPTION_RESERVATION,
  APPLY_PRESCRIPTION_INFO,
  APPLY_PRESCRIPTION_ENTER_TYPE,
} from "../actions/prescription";

const defaultState = {
  lineInfo: { liffId: "", lineId: "", userName: "" },
  systemConstants: null,
  exclusionErrorFlag: false,
  familiesData: [],
};

const systemConstants = (state = defaultState, action) => {
  switch (action.type) {
    case LINE_INFO:
      return { ...state, lineInfo: action.lineInfo };
    case CUSTOMER_SELECTED:
      return { ...state, customerSelected: action.customerSelected };
    case PHARMACY_SELECTED:
      return { ...state, pharmacySelected: action.pharmacySelected };
    case SET_SYSTEM_CONSTANTS:
      return { ...state, systemConstants: action.systemConstants };
    case EXCLUSION_ERROR_FLAG:
      return { ...state, exclusionErrorFlag: action.exclusionErrorFlag };
    case FAMILIES_DATA:
      return { ...state, familiesData: action.familiesData };
    case PRESCRIPTION_TYPE:
      return { ...state, prescriptionType: action.prescriptionType };
    case PRESCRIPTION_DIRECTOR:
      return { ...state, prescriptionDirector: action.prescriptionDirector };
    case APPLY_PRESCRIPTION_INFO:
      return { ...state, applyPrescriptionInfo: action.applyPrescriptionInfo };
    case PRESCRIPTION_RESERVATION:
      return {
        ...state,
        prescriptionReservation: action.prescriptionReservation,
      };
    case APPLY_PRESCRIPTION_ENTER_TYPE:
      return {
        ...state,
        applyPrescriptionEnterType: action.applyPrescriptionEnterType,
      };
    default:
      return { ...state };
  }
};

export default systemConstants;
